import genSign from './utils/sign';
import formatParams from './utils/formatParams';

const antiTheft = ({ videoinfo, _gid, version }) => {
    let videoUrl = '';
    const sver = '';
    // const start = '';
    // const end = '';
    const { vid, uid, from, pver, se, cat, ptype, platform, sourceType, dt, gid } = formatParams(
        videoinfo,
        _gid,
        version,
    );

    const { sign, tm } = genSign({ gid, pver, sver, tm: Date.now(), uid, vid });

    const paramArr = [];

    paramArr.push(`vid=${vid}`);
    paramArr.push(`uid=${uid}`);
    paramArr.push(`from=${from}`);
    paramArr.push(`pver=${pver}`);
    paramArr.push(`sver=${sver}`);
    paramArr.push(`se=${se}`);
    paramArr.push(`cat=${cat}`);
    paramArr.push(`ptype=${ptype}`);
    paramArr.push(`platform=${platform}`);
    paramArr.push(`sourceType=${sourceType}`);
    paramArr.push(`dt=${dt}`);
    paramArr.push(`gid=${gid}`);
    paramArr.push(`sign=${sign}`);
    // paramArr.push(`start=${start}`);
    // paramArr.push(`end=${end}`);
    paramArr.push(`tm=${tm}`);

    videoUrl = paramArr.join('&');

    return videoUrl;
};

export default antiTheft;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.util/app/lib/auth/antiTheft.js